import React from 'react';
import useScreenSize from '../../hooks/useScreenSize/useScreenSize';
import { ScreenSize } from '../../libraries/ScreenSizes';
import { getMergedClassNames } from '../../utils/HTMLutils';
import './Modal.scss';
const rootClassName = 'component-modal-mask';
interface ModalMaskProps {
  className?: string;
  mobileOn?: ScreenSize;
  children?: JSX.Element;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
}
export const ModalMask = (props: ModalMaskProps) => {
  const { rankedSize } = useScreenSize();

  const getProps = () => {
    const p = {
      ...props,
      className: getMergedClassNames([
        rootClassName,
        props.className || '',
        props.mobileOn !== undefined && rankedSize <= props.mobileOn
          ? 'mobile'
          : '',
      ]),
    };
    delete p.mobileOn;
    return p;
  };
  return <div {...getProps()}>{props.children}</div>;
};
